import * as React from "react";

// Navigate
// import { useNavigate } from "react-router-dom";

// CSS
import "@/styles/components/titleStyles.css";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";

// Mui
// import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// Mui Icon
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import UploadIcon from "@mui/icons-material/Upload";

export default function Title(props) {
  // Navigate
  // const navigate = useNavigate();
  const {
    title,
    createName,
    deleteName,
    chipName,
    onClickCreate,
    onClickDelete,
    history,
    checkedValue,
    FunctionOn,
    children,
    padding,
    importExport,
    importName,
    onChangeImport,
  } = props;

  // States
  // const [open, setOpen] = React.useState(true);

  // const FuncButton = styled(Button)((props) => ({
  //   color: "#FFFFFF",
  //   backgroundColor: props.delete ? "#d32f2f" : "#0A9C75",
  //   borderRadius: "16px",
  //   minWidth: "140px",
  // }));

  return (
    <StyledPaper className="titleContainer" padding={padding}>
      <div className="titleWrapper">
        {history && (
          <IconButton onClick={history}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ fontWeight: "bold" }}
        >
          {title}
        </Typography>
      </div>
      {children}
      {chipName && <Chip label={chipName} sx={{ fontWeight: "bold" }} />}
      {FunctionOn &&
        (FunctionOn && checkedValue && checkedValue.length > 0 ? (
          <Tooltip title={deleteName}>
            <IconButton component="label" onChange={onClickDelete}>
              <DeleteForeverIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title={createName}>
            <IconButton component="label" onClick={onClickCreate}>
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
        ))}
      {importExport && (
        <Tooltip title={importName}>
          <IconButton component="label" onChange={onChangeImport}>
            <UploadIcon />
            <input hidden type={"file"} id={"csvFileInput"} accept={".csv"} />
          </IconButton>
        </Tooltip>
      )}
    </StyledPaper>
  );
}
